import HeaderLayout from "./HeaderLayout";
import FooterLayout from "./FooterLayout";
import { Outlet } from "react-router";
import { baseRoutes } from "@base/routes/baseRoutes";
import { responseUI } from "@base/themes/response";
import ImageLinkPopup from "@components/CommonStyles/ImageLinkPopup";
import { useSelector } from "react-redux";
import { RootState } from "@base/store/store";
import useGetHomeModule from "@base/modules/homeModules/hooks/useGetHomeModule";

interface PageLayoutProps {
  children?: React.ReactNode | React.ReactNode[];
}

const PageLayout = (props: PageLayoutProps) => {
  //! state
  const { data } = useGetHomeModule();
  const dataCommon = useSelector((state: RootState) => state.appCommonSlice.dataCommon);

  //! function

  //! render
  return (
    <div className={` `}>
      {/* Page Header */}
      <div className={`mx-auto w-screen sm:w-[600px] md:w-[700px] lg:w-[900px] xl:w-[1200px] h-fit ${responseUI.padding}`}>
        <HeaderLayout />
      </div>

      {/* Page Content */}
      <div className="w-full  pt-2 md:pt-5 xl:pt-0">
        <div className="bg-common-background">
          <Outlet />
        </div>
      </div>

      {/* Page Footer */}
      <div className={`flex w-full  ${responseUI.screen} ${responseUI.padding}`}>
        <FooterLayout />
      </div>

      <ImageLinkPopup
        links={dataCommon?.data.broadcast_news ?? []}
        defaultEnable
        sessionStorageKey={baseRoutes.home}
        routeToCheck={baseRoutes.home}
      />
    </div>
  );
};

export default PageLayout;
